import Card from "./Card";
import ExecuteButton from "./buttons/ExecuteButton";
import Filters from "./Filters";
import React from "react";
import ResponsiveGrid from "../components/list/ResponsiveGrid";
import ResponsiveList from "../components/list/ResponsiveList";
import { TextField } from "react-admin";

const List = (props) => {
  return (
    <ResponsiveList
      {...props}
      split
      type="table"
      perPage={10}
      filters={<Filters />}
      bulkActionButtons={false}
      exporter={false}
    >
      <ResponsiveGrid
        rowBreakpoint="sm"
        cardContent={<Card />}
        target="procedure"
      >
        <TextField />
        <TextField label="Id" source="id" />
        <TextField source="name" label="resources.procedure.label.name" />
        <ExecuteButton record={props.record} {...props} />
      </ResponsiveGrid>
    </ResponsiveList>
  );
};
export default List;
